var map = {
	"./icon_arrows_down.png": "r7N9",
	"./icon_arrows_up.png": "rAEJ",
	"./icon_begin.png": "DJmv",
	"./icon_cachu.png": "cypd",
	"./icon_chat.png": "17YA",
	"./icon_completed.png": "18dg",
	"./icon_curriculum.png": "+aeQ",
	"./icon_double_up_arrow.png": "aeA8",
	"./icon_expression.png": "i45K",
	"./icon_guanli.png": "+n4R",
	"./icon_jiaoshi.png": "4qoe",
	"./icon_jiaoxue.png": "1r7i",
	"./icon_listener.png": "i/Di",
	"./icon_maximize_n.png": "77vm",
	"./icon_maximize_y.png": "Z8ec",
	"./icon_note_discus_0.png": "OE/w",
	"./icon_note_discus_1.png": "7Ynk",
	"./icon_note_discus_2.png": "rbKA",
	"./icon_note_discus_3.png": "DsLt",
	"./icon_null.png": "TP90",
	"./icon_options.png": "vF5L",
	"./icon_pen.png": "s69R",
	"./icon_pending.png": "5Wd7",
	"./icon_quantity.png": "C0Gx",
	"./icon_ranking.png": "Ph2/",
	"./icon_ranking_1.png": "OmW1",
	"./icon_ranking_2.png": "ndJp",
	"./icon_ranking_3.png": "4ISD",
	"./icon_ranking_other.png": "ZhWQ",
	"./icon_scissors.png": "nLd7",
	"./icon_task.png": "oqJT",
	"./icon_training.png": "8aqt",
	"./icon_waiting.png": "+9BN",
	"./icon_xingzheng.png": "8qdn",
	"./icon_xuesheng.png": "IcM1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vMVd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon ^\.\/icon_.*\.png$
// module id = vMVd
// module chunks = 96